<template>
    <div style="max-height: 450px;overflow-y: auto">
      <el-table :data="showTable" border style="width: 100%;font-size: 16px" highlight-current-row
                :header-cell-style="getBackgroundColor" size="small">
        <el-table-column
          type="index"
          label="序号"
          width="55"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          min-width="85"
          align="center">
        </el-table-column>
        <el-table-column
          label="小程序账号"
          min-width="70"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.is_open_applet === 0">不开通</span>
            <span v-if="scope.row.is_open_applet === 1">开通</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createtime"
          label="创建时间"
          min-width="140"
          align="center">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="85"
          align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="90"  class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editHomePerson(scope.row)"></i>
            <i title="刪除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delHomePerson(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <div style="height: 20px;"></div>
    </div>
</template>

<script>
import {deletefamilyperson, queryfamilyperson} from '../../../../api/serviceObject'

export default {
  name: 'familyContact',
  props: {
    familyObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showTable: []
    }
  },
  created () {
    this.golobleObject.updateFamilyNew = this.getFamily
    if (this.familyObj.personId !== '') {
      this.getFamily()
    }
  },
  methods: {
    getBackgroundColor () {
      return {backgroundColor: '#3D83F3', color: '#ffffff', borderColor: '#3D83F3'}
    },
    // 查询联系人
    getFamily () {
      let data = {
        orgid: this.$store.state.user.orgid,
        personid: [this.familyObj.personId]
      }
      queryfamilyperson(data).then(res => {
        this.showTable = res.data.familypersons
      }).catch(() => {})
    },
    // 编辑
    editHomePerson (row) {
      this.$emit('getFatherOpen', row)
    },
    // 删除家庭成员
    delHomePerson (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该联系人【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          familypersonids: [row.id]
        }
        deletefamilyperson(data).then(res => {
          this.$notify({
            title: '成功',
            message: '删除该家庭成员成功',
            type: 'success',
            duration: 2000
          })
          this.getFamily()
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除该家庭成员失败'
          })
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/quick/components/familyContact.vue